import React from 'react';

interface AttendanceWarningProps {
  late: number;
  earlyLeave: number;
  absent: number;
}

const AttendanceWarning: React.FC<AttendanceWarningProps> = ({ late, earlyLeave, absent }) => {
  // 만근수당 위험 계산
  const isAtRisk = late >= 3 || earlyLeave >= 2 || absent >= 1;
  const lateRemaining = Math.max(0, 3 - late);
  const earlyLeaveRemaining = Math.max(0, 2 - earlyLeave);
  const absentRemaining = Math.max(0, 1 - absent);

  if (!isAtRisk && late === 0 && earlyLeave === 0 && absent === 0) {
    return (
      <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-4 border-2 border-green-300">
        <div className="flex items-center gap-3">
          <span className="text-3xl">✅</span>
          <div>
            <p className="font-bold text-green-700">만근수당 안전!</p>
            <p className="text-sm text-green-600">이번 달 지각/조퇴/결근 없음</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`rounded-xl p-4 border-2 ${
      isAtRisk 
        ? 'bg-gradient-to-r from-red-50 to-pink-50 border-red-300' 
        : 'bg-gradient-to-r from-yellow-50 to-amber-50 border-yellow-300'
    }`}>
      <div className="flex items-center gap-3 mb-3">
        <span className="text-3xl">{isAtRisk ? '⚠️' : '💰'}</span>
        <div>
          <p className={`font-bold ${isAtRisk ? 'text-red-700' : 'text-yellow-700'}`}>
            {isAtRisk ? '만근수당 위험!' : '만근수당 트래커'}
          </p>
          <p className={`text-sm ${isAtRisk ? 'text-red-600' : 'text-yellow-600'}`}>
            {isAtRisk ? '이번 달 만근수당 받을 수 없습니다' : '이번 달 출퇴근 현황'}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-3 text-center">
        {/* 지각 */}
        <div className={`rounded-lg p-3 ${late >= 3 ? 'bg-red-100' : 'bg-gray-100'}`}>
          <div className="text-xs text-gray-600 mb-1">지각</div>
          <div className={`text-2xl font-bold ${late >= 3 ? 'text-red-600' : 'text-gray-700'}`}>
            {late}
          </div>
          <div className="text-xs text-gray-500 mt-1">
            {late >= 3 ? '한계 초과!' : `${lateRemaining}회 남음`}
          </div>
        </div>

        {/* 조퇴 */}
        <div className={`rounded-lg p-3 ${earlyLeave >= 2 ? 'bg-red-100' : 'bg-gray-100'}`}>
          <div className="text-xs text-gray-600 mb-1">조퇴</div>
          <div className={`text-2xl font-bold ${earlyLeave >= 2 ? 'text-red-600' : 'text-gray-700'}`}>
            {earlyLeave}
          </div>
          <div className="text-xs text-gray-500 mt-1">
            {earlyLeave >= 2 ? '한계 초과!' : `${earlyLeaveRemaining}회 남음`}
          </div>
        </div>

        {/* 결근 */}
        <div className={`rounded-lg p-3 ${absent >= 1 ? 'bg-red-100' : 'bg-gray-100'}`}>
          <div className="text-xs text-gray-600 mb-1">결근</div>
          <div className={`text-2xl font-bold ${absent >= 1 ? 'text-red-600' : 'text-gray-700'}`}>
            {absent}
          </div>
          <div className="text-xs text-gray-500 mt-1">
            {absent >= 1 ? '한계 초과!' : `${absentRemaining}회 남음`}
          </div>
        </div>
      </div>

      <div className="mt-3 text-xs text-gray-600 text-center">
        만근수당 기준: 지각 3회, 조퇴 2회, 결근 1회 초과 시 제외
      </div>
    </div>
  );
};

export default AttendanceWarning;
